const initSeasonTabs = (root) => {
  const buttons = Array.from(root.querySelectorAll('.season-tabs__trigger'));
  const panels = Array.from(root.querySelectorAll('.season-tabs__panel'));

  if (!buttons.length || !panels.length) {
    return;
  }

  const setActive = (id) => {
    let activePanel = null;

    buttons.forEach((button) => {
      const isActive = button.dataset.tabTarget === id;
      button.classList.toggle('is-active', isActive);
      button.setAttribute('aria-selected', isActive ? 'true' : 'false');
      button.setAttribute('tabindex', isActive ? '0' : '-1');
    });

    panels.forEach((panel) => {
      const isActive = panel.dataset.tabId === id;
      panel.classList.toggle('is-active', isActive);
      panel.hidden = !isActive;

       if (isActive) {
        activePanel = panel;
      }
    });

    return activePanel;
  };

  root.setAttribute('data-tabs-initialized', 'true');

  buttons.forEach((button) => {
    button.addEventListener('click', (event) => {
      event.preventDefault();
      const activePanel = setActive(button.dataset.tabTarget);
      const scrollTarget = activePanel?.firstElementChild || activePanel;

      if (scrollTarget) {
        requestAnimationFrame(() => {
          const targetTop = window.scrollY + scrollTarget.getBoundingClientRect().top - 100;

          window.scrollTo({
            top: Math.max(targetTop, 0),
            behavior: 'smooth',
          });
        });
      }
    });
  });
};

const initAllSeasonTabs = () => {
  document.querySelectorAll('.season-tabs').forEach(initSeasonTabs);
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initAllSeasonTabs);
} else {
  initAllSeasonTabs();
}
